import { customerApi } from "../../utils/apiConfig";

// Backend: /api/v1/kurumsal-hafiza/admin/personel-yonetimi (routes/admin/personelYonetimi.js)
const BASE = "/personel-yonetimi";

const authConfig = (params) => ({
  params,
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

export const getPersonelContext = () => customerApi.get(`${BASE}/context`, authConfig());
export const getPersonelListe = (params) => customerApi.get(`${BASE}/liste`, authConfig(params));
export const ekleKullanici = (payload) => customerApi.post(`${BASE}/ekle`, payload, authConfig());
export const guncelleKullanici = (payload) => customerApi.post(`${BASE}/guncelle`, payload, authConfig());
export const kullaniciDurum = (id, aktif) => customerApi.post(`${BASE}/durum`, { id, aktif }, authConfig());
export const kullaniciSifreSifirla = (id) => customerApi.post(`${BASE}/sifre-sifirla`, { id }, authConfig());
export const ekleDepartman = (payload) => customerApi.post(`${BASE}/departman/ekle`, payload, authConfig());
export const guncelleDepartman = (payload) => customerApi.post(`${BASE}/departman/guncelle`, payload, authConfig());

export const apiHata = (error) =>
  error?.response?.data?.detail ||
  error?.response?.data?.msg ||
  error?.response?.data?.message ||
  error?.message ||
  "İşlem sırasında bir hata oluştu.";
